import React, { Component } from "react";
import {
  DKButton,
  DKCalendar,
  DKIcons,
  DKLine,
  DKLabel,
} from "deskera-ui-library";
import Utility from "../../utility/Utility";

export default class DKDateTime extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: this.props.selectedDate
        ? this.props.selectedDate
        : new Date(),
      hours: 0,
      minutes: 0,
      amPm: "am",
      is12Hour: this.props.is12Hour ? this.props.is12Hour : false,
      date: null,
      time: null,
      textBoxWidth: this.props.hasMaxHours ? 45:33
    };
  }
  componentDidMount() {
    this.initDateTime();
  }

  render() {
    return (
      <div
        className={`column align-self-center parent-width ` + this.props.className}
      >
        <div className="row row-responsive justify-content-center-mobile">
          {!this.props.hideCalendar && <DKCalendar
            onSelectDate={(date) => {
              this.onSelectDate(date);
            }}
            selectedDate={new Date(this.state.selectedDate)}
          />}
          <div className="row justify-content-center parent-width mt-m pt-m mb-m">
            <div className="column align-items-center ml-m">
              <div className="">
                {this.getIncrementer((this.state.hours), "hour")}
              </div>
            </div>
            <div className="column align-items-center ml-m fw-h">:</div>
            <div className="column align-items-center ml-m mr-m">
              <div className="">
                {this.getIncrementer((this.state.minutes), "min")}
              </div>
            </div>
            {this.state.is12Hour && (
              <div className="column align-items-center mr-m">
                <DKButton
                  title="AM"
                  className={
                    this.state.amPm === "am"
                      ? `bg-app border-m mb-s text-white`
                      : `bg-white border-m mb-s`
                  }
                  onClick={() => {
                    this.setamPm("am");
                  }}
                />
                <DKButton
                  title="PM"
                  className={
                    this.state.amPm === "pm"
                      ? `bg-app border-m mb-s text-white`
                      : `bg-white border-m mb-s`
                  }
                  onClick={() => {
                    this.setamPm("pm");
                  }}
                />
                <div></div>
              </div>
            )}
          </div>
        </div>
        <DKLine className="m-v-m" />
        {this.getFooter()}
      </div>
    );
  }
  getFooter = () => {
    return (<div className="row justify-content-between">
      {!this.props.hideFooterDateTime && <DKLabel text={`${!this.props.hideCalendar ? this.state.date+", ":""} ${this.state.time}`} className="text-gray" />}
      <div className="row ml-auto" style={{ width: "auto" }}>
        <DKButton
          title="Cancel"
          className="bg-gray1 border-m "
          onClick={() => {
            this.props.onClose();
          }}
        />
        <DKButton
          title="Done"
          className="bg-app text-white ml-r"
          onClick={() => {
            this.saveDateTime();
          }}
        />
      </div>
    </div>)
  }
  getMonth(date) {
    if (this.props.isDateRange) {
      return this.props.selectedStartDate
        ? new Date(this.props.selectedStartDate).getMonth() + 1
        : new Date().getMonth() + 1;
    } else {
      return date ? date.getMonth() + 1 : new Date().getMonth() + 1;
    }
  }

  getAmPM = (hour) => {
    let value = "am";
    if (hour >= 12) {
      value = "pm";
    } else {
      value = "am";
    }
    return value;
  };

  setamPm = (value) => {
    this.setState({ amPm: value }, () => this.setDateTime());
  };

  initDateTime = () => {
    let selectedDate = this.state.selectedDate;
    let date = this.props.hasMaxHours ? selectedDate: new Date(selectedDate);
    let hours ;
    let amPm;
    if (this.props.hasMaxHours) {
      const hhMM=date.split(":")

      this.setState({ hours: hhMM[0], minutes: hhMM[1], amPm: '' }, () => this.getDateTimeShow());
    } else {
      amPm = this.getAmPM(date.getHours());
      hours = date.getHours();
      if (this.state.is12Hour) {
        hours = amPm === 'am' ? hours : Math.abs(hours - 12)
      }
      this.setState({ hours: hours, minutes: date.getMinutes(), amPm: amPm }, () => this.getDateTimeShow());
    }
  };

  getIncrementer = (data, type) => {
    let value = data;
    if (data < 10 && !this.props.hasMaxHours) {
      value = "0" + data;
    }
    return (
      <div className={"row " + this.props.className}>
        <div
          className="column border-radius-s align-items-center unselectable "
          style={{ overflow: "hidden", width: this.state.textBoxWidth }}
        >
          <DKButton
            icon={DKIcons.ic_arrow_up}
            className=" border-radius-none bg-white"
            onClick={() => this.onChange(1, type)}
          />
          <input
            type="text"
            value={value}
            onChange={(value) => this.onEditValue(value, type)}
            className="row justify-content-center bg-gray1 border-m app-font p-s border-box"
          />
          <DKButton
            icon={DKIcons.ic_arrow_down}
            className="border-radius-none bg-white"
            onClick={() => this.onChange(-1, type)}
          />
        </div>
      </div>
    );
  };

  onEditValue = (value, type) => {
    let inputValue = parseInt(value.target.value);
    if (type === "hour") {
      if (
        inputValue !== "" &&
        !this.state.is12Hour &&
        inputValue >= 0 &&
        inputValue <= 23 &&
        !this.props.hasMaxHours
      ) {
        this.setState({ hours: inputValue },() => this.setDateTime() );
      } else if (
        inputValue !== "" &&
        this.state.is12Hour &&
        inputValue >= 0 &&
        inputValue <= 11 &&
        !this.props.hasMaxHours
      ) {
        let formatAMPM = this.getAmPM(inputValue)
        if (formatAMPM === "pm") {
          inputValue = inputValue - 12
        }
        this.setState({ hours: inputValue },() => this.setDateTime());
      } else if(inputValue !== "" &&  this.props.hasMaxHours && inputValue<=this.props.hasMaxHours) {
        this.setState({ hours: inputValue },() => this.setDateTime());
      } else {
        let date = new Date();
        let hours = date.getHours()
        let formatAMPM = this.getAmPM(hours)
        if (this.state.is12Hour && formatAMPM === "pm") {
          hours = hours - 12
        }
        this.setState({ hours: hours },() => this.setDateTime());
      }
    }

    if (type === "min") {
      if (inputValue >= 0 && inputValue <= 59) {
        this.setState({ minutes: inputValue },() => this.setDateTime());
      } else {
        let date = new Date();
        this.setState({ minutes: date.getMinutes() },() => this.setDateTime());
      }
    }
  };

  onChange = (by, type) => {
    let val;
    if (type === "hour") {
      val = parseInt(this.state.hours);
    }
    if (type === "min") {
      val = parseInt(this.state.minutes);
    }
    val = val + by;
    if (type === "hour") {
      if ((!this.state.is12Hour && val > 23 && !this.props.hasMaxHours ) || (this.props.hasMaxHours && val>this.props.hasMaxHours)) {
        return;
      }
      if (this.state.is12Hour && val > 11) {
        return;
      }
    }
    if (type === "min") {
      if (val > 59) {
        return;
      }
    }
    if (type === "min" || type === "hour") {
      if (val === -1) {
        return;
      }
    }
    if (type === "hour") {
      this.setState({ hours: val }, () => this.setDateTime());
    }
    if (type === "min") {
      this.setState({ minutes: val }, () => this.setDateTime());
    }
  };

  onSelectDate = (date) => {
    this.setState({ selectedDate: date }, () => this.setDateTime());
  };

  setDateTime = () => {
    let newSelectedDate = this.state.selectedDate;
    let hours = this.state.hours;
    let min = this.state.minutes;

    if (this.state.is12Hour && this.state.amPm === "pm") {
      hours = hours + 12;
    }
    if (newSelectedDate === undefined) {
      newSelectedDate = new Date();
    }
    if(this.props.hasMaxHours) {
      this.setState({ selectedDate: `${hours}:${min}` }, () => this.getDateTimeShow());
    } else {
      let convertDateNTime = new Date(newSelectedDate);
      convertDateNTime = convertDateNTime.setHours(hours, min, 0, 0);
      var newDateNTime = new Date(convertDateNTime);
      this.setState({ selectedDate: newDateNTime.toISOString() }, () => this.getDateTimeShow());
    }
  }
  saveDateTime = () => {
    if(this.props.hasMaxHours) {
      this.props.onSave(`${this.state.hours}:${this.state.minutes}`);
    } else {
      this.props.onSave(this.state.selectedDate);
    }
    
  };

  getDateTimeShow = () => {
    let date = (!this.props.hasMaxHours && this.state.selectedDate) ? new Date(this.state.selectedDate) : new Date();
    this.setState({ date: date.toDateString(), time: this.formatAMPM(date) });
  };

  formatAMPM = (date) => {
    if(this.props.hasMaxHours) {
      if(!Utility.isEmpty(this.state.selectedDate)) {
          const hhMM = this.state.selectedDate.split(":");
          hhMM[1] = hhMM[1].length==1 ? "0"+hhMM[1]:hhMM[1];
          hhMM[0] = hhMM[0].length==1 ? "0"+hhMM[0]:hhMM[0];
          return `${hhMM[0]}:${hhMM[1]}`
      }
      return date
  }
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? (hours < 10 ? "0" + hours : hours) : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };
}
